import { c as e } from "./index-BpNK5r1N.mjs";
const a = e(
  [
    "inline-flex items-center justify-center align-middle no-underline",
    "select-none appearance-none rounded-8 px-16 py-4",
    "aria-disabled:pointer-events-none aria-disabled:cursor-not-allowed aria-disabled:border-0",
    "aria-disabled:bg-interaction-neutral-disable-main aria-disabled:text-static-white"
  ],
  {
    variants: {
      fullWidth: {
        true: "w-full",
        false: "w-fit"
      },
      weight: {
        regular: "",
        bold: "!font-bold"
      },
      size: {
        xxlarge: "min-h-64 px-16 typography-subtitle-20-regular rounded-12",
        large: "min-h-48 px-16 typography-subtitle-16-regular rounded-8",
        medium: "min-h-40 px-16 typography-body-14-regular rounded-8",
        small: "min-h-32  px-8 typography-body-12-regular rounded-6"
      },
      pcSize: {
        xxlarge: "pc:min-h-64 pc:px-16 pc:typography-subtitle-20-regular pc:rounded-12",
        large: "pc:min-h-48 pc:px-16 pc:typography-subtitle-16-regular pc:rounded-8",
        medium: "pc:min-h-40 pc:px-16 pc:typography-body-14-regular pc:rounded-8",
        small: "pc:min-h-32 pc:px-8 pc:typography-body-12-regular pc:rounded-6"
      },
      isCapsule: {
        true: "!rounded-full",
        false: ""
      },
      theme: {
        filled_primary: [
          "bg-fill-primary-main text-static-white",
          "hover-never:bg-interaction-primary-presshover-strong3 active:bg-interaction-primary-presshover-strong3"
        ],
        filled_secondary: [
          "bg-fill-primary-weak text-text-primary-main",
          "hover-never:bg-interaction-primary-presshover-weak1 active:bg-interaction-primary-presshover-weak1"
        ],
        filled_basic: [
          "bg-static-white text-text-neutral-main",
          "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1"
        ],
        outlined_primary: [
          "border border-line-primary-main bg-static-white text-text-primary-main",
          "hover-never:bg-interaction-primary-presshover-weak1 active:bg-interaction-primary-presshover-weak1"
        ],
        outlined_secondary: [
          "border border-line-neutral-main bg-static-white text-text-neutral-main",
          "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1"
        ],
        outlined_basic: [
          "border border-line-neutral-weak3 bg-static-white text-text-neutral-main",
          "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1"
        ],
        ghost: [
          "bg-transparent text-text-neutral-main",
          "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
          "aria-disabled:bg-transparent aria-disabled:text-interaction-neutral-disable-main"
        ],
        transparent: [
          "bg-transparent text-static-white",
          "hover-never:bg-interaction-transparent-presshover-main active:bg-interaction-transparent-presshover-main",
          "aria-disabled:bg-transparent aria-disabled:text-interaction-transparent-disable-main"
        ]
      }
    },
    defaultVariants: {
      fullWidth: !1,
      weight: "bold",
      theme: "filled_primary",
      isCapsule: !1
    }
  }
), t = e("", {
  variants: {
    direction: {
      left: "mr-2",
      right: "ml-2"
    },
    size: {
      xxlarge: "size-22",
      large: "size-18",
      medium: "size-16",
      small: "size-14"
    },
    pcSize: {
      xxlarge: "pc:size-22",
      large: "pc:size-18",
      medium: "pc:size-16",
      small: "pc:size-14"
    }
  },
  defaultVariants: {
    direction: "left"
  }
});
export {
  t as a,
  a as r
};
